import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  PARTNER_ID: {
    DOM: ' ',
    INTL: ' '
  }
}

export const Concert = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  VENDOR.CONCERT = { ...template, ...VENDOR.CONCERT }
  const { CONCERT } = VENDOR
  const { PARTNER_ID } = CONCERT
  const { DOM, INTL } = PARTNER_ID
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='Concert-panel-content'
        id='Concert-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Concert</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Table size='small' aria-label='concert-partner-id-table'>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '180px' }}><Typography variant='h6'>Partner IDs</Typography></TableCell>
              <TableCell>Domestic</TableCell>
              <TableCell>International</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  margin='none'
                  value={DOM}
                  error={errors.PREBID_CONCERT_PIDD}
                  helperText={errors.PREBID_CONCERT_PIDD && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.CONCERT.PARTNER_ID.DOM = value
                    setErrors({ ...errors, PREBID_CONCERT_PIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  margin='none'
                  value={INTL}
                  error={errors.PREBID_CONCERT_PIDI}
                  helperText={errors.PREBID_CONCERT_PIDI && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.CONCERT.PARTNER_ID.INTL = value
                    setErrors({ ...errors, PREBID_CONCERT_PIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
